import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewApi = AiseaApiFactory.get("enterpriseCrew");
const enterpriseManningVesselApi = AiseaApiFactory.get(
  "enterpriseManningVessel"
);
const enterpriseLaborTemplateApi = AiseaApiFactory.get(
  "enterpriseLaborTemplate"
);

export default {
  async setCrewAccount({ commit }, enterpriseCrewId) {
    const res = await enterpriseCrewApi.fetch(enterpriseCrewId);
    commit("SET_CREW_ACCOUNT", res.data);
  },
  async clearCrewAccount({ commit }) {
    commit("CLEAR_CREW_ACCOUNT");
  },
  async setCrewList({ commit }, payload) {
    const res = await enterpriseCrewApi.search({
      active_type: "ACTIVE",
      sort_column: payload.sortColumn || "NAME",
      sort_order: "ASC",
      page: 0,
      size: 999,
    });
    commit("SET_CREW_LIST", res.data.enterprise_crews);
  },

  async getAlertList({ state }, payload) {
    let alertList = [];

    if (payload.dispType === "labor" && state.crewAccount.id) {
      // 個人単位のアラートチェック

      // 労務情報未登録（個人）:
      if (
        !state.crewAccount.crew_labors ||
        state.crewAccount.crew_labors.length === 0
      ) {
        // 表示している船員の労務情報の必須項目に未登録の情報が存在する場合

        alertList.push({
          title: "労務情報未登録（個人）",
          alertLevel: "ALERT",
          msg:
            "労務情報が登録されていません。労務管理記録簿を適切に作成するには、労務情報を登録してください。",
          linkTo: {
            // name: "enterprise-management-crew-labor",
            name: "enterprise-management-crew-labors",
            params: { id: state.crewAccount.id },
            // query: { tab: '3' },
          }, // CC-1: 労務情報
        });
      }

      // ７月末リリースでは乗船期間アラートを出さない為、コメントアウト
      // // 乗船期間未登録（個人）:
      // const resCrewManningVessel = await enterpriseCrewManningVesselApi.search(state.crewAccount.id, {
      //         started_at:   moment().local().startOf('day').add(-10, 'year').format('YYYY-MM-DD'),
      //         ended_at:     moment().local().startOf('day').add( 10, 'year').format('YYYY-MM-DD'),
      //         sort_column: 'DAYTIME_IN',
      //         sort_order:  'ASC',
      //         page:   0,
      //         size: 999,
      //       });
      // const crewManningVessels = resCrewManningVessel.data.enterprise_manning_vessel_crews || [];
      // const todayYmd =  moment().local().startOf('day').format('YYYY-MM-DD');
      // const todayCrewManningVessels = crewManningVessels.filter(crewManningVessel => {
      //   return crewManningVessel.daytime_in <= todayYmd && crewManningVessel.daytime_out >= todayYmd;
      // });

      // // if ( crewManningVessels.length === 0 || todayCrewManningVessels.length === 0 ) {
      // if ( crewManningVessels.length === 0 ) {
      //   // 1. 表示している船員の乗船期間が未登録の場合
      //   // 2. 登録されている乗船期間に「当日」が含まれない場合 <-- ７月末リリースでは実施しない

      //   alertList.push({
      //     title: "乗船期間未登録（個人）",
      //     alertLevel: "ALERT",
      //     msg: "乗船期間が登録されていません。労務管理記録簿を適切に作成するには、乗船期間を登録してください。",
      //     linkTo: {
      //       name: "enterprise-management-manning-vessels-list",
      //       param: { id: state.crewAccount.id },
      //     }, // CA-1: 乗船期間
      //   });
      // }
    } else if (payload.dispType === "corporate") {
      // 法人単位のアラートチェック

      // 船舶情報未登録 (L-1も):
      const resManningVessel = await enterpriseManningVesselApi.search({
        name: null,
        active_type: "ACTIVE",
        sort_column: null,
        sort_order: null,
        page: 0,
        size: 999,
      });
      const vessels = resManningVessel.data.manning_vessels || [];
      if (vessels.length === 0) {
        // 法人に紐づく船舶が1隻も登録されていない
        alertList.push({
          title: "船舶情報未登録",
          alertLevel: "ALERT",
          msg:
            "船舶が登録されていません。サービスの利用を開始するには、船舶を登録してください。",
          linkTo: {
            name: "enterprise-management-crew-vessels-list",
            query: { tab: "1" },
          }, // M-2: 船舶情報
        });
      }

      // 労務基本情報未登録 (L-1も):
      let resLaborTemplate = await enterpriseLaborTemplateApi.search(payload);
      const templates = resLaborTemplate.data.templates || [];

      if (templates.length === 0) {
        // 法人に紐づく労務基本情報が一つも登録されていない（M-3=労務基本情報に表示する情報がない状態）
        alertList.push({
          title: "労務基本情報未登録",
          alertLevel: "WARNING",
          msg:
            "労務基本情報が登録されていません。新規に登録する船員に自動で労務情報を付与するには、労務基本情報を登録してください。",
          linkTo: {
            name: "enterprise-management-crew-labor-template",
            query: { tab: "0" },
          }, // M-3: 労務基本情報
        });
      }

      // 労務情報未登録（法人）:
      // 従業員を全ナメ
      const crewLaborYetList = state.crewList.filter(crew => {
        return crew.crew_labors.length === 0;
      });
      if (crewLaborYetList.length > 0) {
        // 労務情報が紐付いていない船員が存在する

        alertList.push({
          title: "労務情報未登録（法人）",
          alertLevel: "ALERT",
          msg: `労務情報が登録されていない船員が ${crewLaborYetList.length} 名います。労務管理記録簿を適切に作成するには、労務情報を登録してください。`,
          linkTo: {
            name: "enterprise-management-crew-list",
          }, // CL-1: 船員一覧
        });
      }

      // ７月末リリースでは乗船期間アラートを出さない為、コメントアウト
      // // 乗船期間未登録（法人）:
      // // 従業員を全ナメ x 各々の乗船期間を全ナメ
      // const manninVesselYetJobs = state.crewList.map(crew => {
      //   return new Promise( async ( resolve ) => {
      //     const resCrewManningVessel = await enterpriseCrewManningVesselApi.search(crew.id, {
      //       started_at:   moment().local().startOf('day').add(-10, 'year').format('YYYY-MM-DD'),
      //       ended_at:     moment().local().startOf('day').add( 10, 'year').format('YYYY-MM-DD'),
      //       sort_column: 'DAYTIME_IN',
      //       sort_order:  'ASC',
      //       page:   0,
      //       size: 999,
      //     });
      //     const crewManningVessels = resCrewManningVessel.data.enterprise_manning_vessel_crews || [];
      //     const todayYmd =  moment().local().startOf('day').format('YYYY-MM-DD');
      //     const todayCrewManningVessels = crewManningVessels.filter(crewManningVessel => {
      //       return crewManningVessel.daytime_in <= todayYmd && crewManningVessel.daytime_out >= todayYmd;
      //     });
      //     // if ( crewManningVessels.length === 0 || todayCrewManningVessels.length === 0 ) {
      //     if ( crewManningVessels.length === 0 ) {
      //       // 1. 表示している船員の乗船期間が未登録の場合
      //       // 2. 登録されている乗船期間に「当日」が含まれない場合 <-- ７月末リリースでは実施しない
      //       resolve(crew);
      //     } else {
      //       resolve(null);
      //     }
      //   });
      // });

      // const manninVesselYetList = await Promise.all(manninVesselYetJobs);

      // if ( manninVesselYetList.filter(x => x != null).length > 0 ) {
      //   // 1. 表示している船員の乗船期間が未登録の場合
      //   // 2. 登録されている乗船期間に「当日」が含まれない場合

      //   alertList.push({
      //     title: "乗船期間未登録（法人）",
      //     alertLevel: "ALERT",
      //     msg: `乗船期間が登録されていない船員が ${ manninVesselYetList.filter(x =>  x != null).length } 名います。労務管理記録簿を適切に作成するには、乗船期間を登録してください。`,
      //     linkTo: {
      //       name: "enterprise-management-crew-list",
      //     }, // CL-1: 船員一覧?
      //   });
      // }

      // // 労働時間超過（週）:
      // // Work hours of a day. 特定の1日の労働時間合計。分単位（秒四捨五入）。 SUM(worked_hrs in a_day)
      // //  統計: GET /v1/admin/enterprises/crews/timesheet/records 船員労務状況を取得
      // const resTimesheetSummary = await enterpriseCrewTimesheetRecordApi.search({
      //   page: 0,
      //   size: 999,
      // });
      // const crewRimesheetRecords = resTimesheetSummary.data.inline_response_enterprise_crew_timesheet_records || [];
      // const overWorkedHoursList = crewRimesheetRecords.filter(crew => {
      //   return crew.hour_of_work1w > 72;
      // });
      // if ( overWorkedHoursList.length > 0 ) {
      //   // 過去7日以内の労働時間が72時間を超過した船員が1人以上いる場合。
      //   alertList.push({
      //     title: "労務情報未登録（法人）",
      //     alertLevel: "ALERT",
      //     msg: `週の法定残業時間（週）を超過した船員が ${overWorkedHoursList.length} 名います。休暇を与えてください。`,
      //     linkTo: {
      //       name: "enterprise-management-crew-list",
      //     }, // CL-1: 船員一覧?
      //   });
      // }
    }

    return alertList;
  },
};
